/* ==========================================================================
   Pixlcat CRO preview (2026-10-19). Draft theme only.
   1. Next ship date line on product pages (ships Mon-Wed; orders by noon Eastern ship the same day)
   2. Build-your-own picker: live box summary + Add to cart gated until both flavors are picked
   3. Cart: one-tap coffee add, gift note saved as a cart attribute
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DAY = 864e5;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  /* ---------- 1. Ship date ---------- */
  function easternNow() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      return null;
    }
    var n = { y: +parts.year, m: +parts.month, d: +parts.day, h: (+parts.hour) % 24 };
    return isNaN(n.y) || isNaN(n.h) ? null : n;
  }

  function nextShip() {
    var n = easternNow();
    if (!n) return null;
    var base = Date.UTC(n.y, n.m - 1, n.d);
    for (var i = 0; i <= 14; i++) {
      var ship = new Date(base + i * DAY);
      var wd = ship.getUTCDay();
      if (wd < 1 || wd > 3) continue; // ships Mon, Tue, Wed only
      if (i === 0 && n.h >= 12) continue; // cutoff is noon Eastern on the ship day itself
      return { ship: ship, cutoff: ship, offset: i };
    }
    return null;
  }

  var shipLine = null;
  function shipText() {
    if (shipLine !== null) return shipLine;
    var r = nextShip();
    if (!r) return (shipLine = '');
    var on = WD[r.ship.getUTCDay()] + ', ' + MO[r.ship.getUTCMonth()] + ' ' + r.ship.getUTCDate();
    // Orders by noon Eastern ship the same day, so the cutoff day and the ship day are the same day
    var when = r.offset === 0 ? 'today to ship today' : r.offset === 1 ? 'tomorrow to ship ' + on : on + ' to ship that day';
    shipLine = 'Baked to order. Order by noon Eastern ' + when + '. Arrives 1 to 3 days after it ships.';
    return shipLine;
  }

  function applyShipDates() {
    var els = document.querySelectorAll('[data-pxc-shipdate]');
    if (!els.length) return;
    var t = shipText();
    if (!t) return;
    for (var i = 0; i < els.length; i++) setText(els[i], t);
  }

  /* ---------- 2. Build-your-own picker ---------- */
  var picked = {}; // product id -> { fieldsetIndex: true }
  var variantInUrl = /[?&]variant=\d+/.test(location.search);

  function pickerState(vp) {
    var k = vp.getAttribute('data-product-id') || 'p';
    return picked[k] || (picked[k] = {});
  }

  function fieldsets(vp) {
    return vp.querySelectorAll('.pxc-flavor-fieldset');
  }

  function remaining(vp) {
    var st = pickerState(vp);
    var fs = fieldsets(vp);
    var left = 0;
    for (var i = 0; i < fs.length; i++) {
      if (!variantInUrl && !st[fs[i].getAttribute('data-fieldset-index')]) left++;
    }
    return left;
  }

  function piecesFrom(legend) {
    var m = (legend || '').match(/\((\d+)\s*pieces?\)/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  function summaryText(vp) {
    var fs = fieldsets(vp);
    var counts = {};
    var order = [];
    for (var i = 0; i < fs.length; i++) {
      var input = fs[i].querySelector('input:checked');
      var legend = fs[i].querySelector('legend');
      if (!input) return '';
      var name = input.value;
      var n = piecesFrom(legend && legend.textContent);
      if (!(name in counts)) { counts[name] = 0; order.push(name); }
      counts[name] += n;
    }
    return 'Your box: ' + order.map(function (name) {
      return (counts[name] ? counts[name] + ' ' : '') + name;
    }).join(' + ');
  }

  function gateLabel(left) {
    return left >= 2 ? 'Pick 2 flavors' : 'Pick 1 more flavor';
  }

  function scopeOf(el) {
    return el.closest('dialog, quick-add-modal, .shopify-section') || document;
  }

  function addButtons(scope) {
    return scope.querySelectorAll('add-to-cart-component button[type="submit"], button[name="add"]');
  }

  function labelEl(btn) {
    return btn.querySelector('.add-to-cart-text__content > span > span') ||
      btn.querySelector('.add-to-cart-text__content') || btn;
  }

  function applyPicker(vp) {
    var st = pickerState(vp);
    var fs = fieldsets(vp);
    if (!fs.length) return;
    for (var i = 0; i < fs.length; i++) {
      var isPicked = variantInUrl || st[fs[i].getAttribute('data-fieldset-index')];
      if (isPicked) {
        if (fs[i].hasAttribute('data-pxc-unpicked')) fs[i].removeAttribute('data-pxc-unpicked');
      } else if (!fs[i].hasAttribute('data-pxc-unpicked')) {
        fs[i].setAttribute('data-pxc-unpicked', '');
      }
    }
    var left = remaining(vp);
    var summary = vp.querySelector('[data-pxc-summary]');
    if (summary) {
      if (left === 0) {
        setText(summary, summaryText(vp));
        if (summary.getAttribute('data-state') !== 'done') summary.setAttribute('data-state', 'done');
      } else {
        var per = piecesFrom((fs[0].querySelector('legend') || {}).textContent);
        setText(summary, left >= 2
          ? 'Pick 2 flavors' + (per ? ', ' + per + ' pieces each.' : '.')
          : 'Pick 1 more flavor to fill your box.');
        if (summary.hasAttribute('data-state')) summary.removeAttribute('data-state');
      }
    }
    var scope = scopeOf(vp);
    var btns = addButtons(scope);
    for (var b = 0; b < btns.length; b++) relabel(btns[b], left);
    if (vp.getAttribute('data-template-product-match') === 'true') {
      var sticky = document.querySelector('sticky-atc [data-sticky-atc-btn]');
      if (sticky) relabel(sticky, left);
    }
  }

  function relabel(btn, left) {
    var el = labelEl(btn);
    var cur = el.textContent.trim();
    var isGate = cur === 'Pick 2 flavors' || cur === 'Pick 1 more flavor';
    // Track the theme's own label (Add to cart, Sold out...) so it comes back once both flavors are picked
    if (!isGate && cur && btn.getAttribute('data-pxc-label') !== cur) btn.setAttribute('data-pxc-label', cur);
    var want = null;
    if (left > 0) want = gateLabel(left);
    else if (isGate) want = btn.getAttribute('data-pxc-label') || 'Add to cart';
    if (want === null) return;
    setText(el, want);
    if (btn.hasAttribute('aria-label') && btn.getAttribute('aria-label') !== want) btn.setAttribute('aria-label', want);
  }

  function applyPickers() {
    var vps = document.querySelectorAll('variant-picker.pxc-byo-picker');
    for (var i = 0; i < vps.length; i++) applyPicker(vps[i]);
  }

  function markPicked(target) {
    var fs = target.closest && target.closest('.pxc-flavor-fieldset');
    if (!fs) return;
    var vp = fs.closest('variant-picker');
    if (!vp) return;
    pickerState(vp)[fs.getAttribute('data-fieldset-index')] = true;
    fs.removeAttribute('data-pxc-unpicked');
    schedule();
  }

  function pickerFor(btn) {
    var scope = scopeOf(btn);
    return scope.querySelector ? scope.querySelector('variant-picker.pxc-byo-picker') : null;
  }

  function nudge(vp) {
    var fs = vp.querySelector('.pxc-flavor-fieldset[data-pxc-unpicked]');
    if (!fs) return;
    try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { fs.scrollIntoView(); }
    fs.classList.remove('pxc-shake');
    void fs.offsetWidth;
    fs.classList.add('pxc-shake');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.pxc-flavor-fieldset .variant-option__button-label')) {
      markPicked(t);
      return;
    }
    var btn = t.closest('add-to-cart-component button[type="submit"], button[name="add"]');
    if (!btn) return;
    var vp = pickerFor(btn);
    if (!vp || remaining(vp) === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge(vp);
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pxc-flavor-fieldset')) markPicked(e.target);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    var vp = pickerFor(form);
    if (!vp || remaining(vp) === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge(vp);
  }, true);

  /* ---------- 3. Cart: one-tap coffee, gift note ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-pxc-addon-btn]');
    if (!b) return;
    e.preventDefault();
    var row = b.closest('[data-pxc-addon-variant]');
    var id = row ? parseInt(row.getAttribute('data-pxc-addon-variant'), 10) : 0;
    if (!id) return;
    var original = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding...';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return fetch(ROOT + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        b.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'pxc-cart-addon', data: { source: 'pxc-cart-addon', itemCount: cart.item_count } }
        }));
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = original;
      });
  });

  var giftTimer = null;
  function saveGiftNote(value) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift note': value } })
    }).catch(function () {});
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-pxc-gift-note]')) return;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () { saveGiftNote(t.value); }, 600);
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-pxc-gift-note]')) return;
    clearTimeout(giftTimer);
    saveGiftNote(t.value);
  });

  /* ---------- Sticky bar title: the short name only ---------- */
  /* Design pass fix 4: no middot join; the sub line already shows in the page heading */
  function applyStickyTitle() {
    var t = document.querySelector('sticky-atc .title');
    var h = document.querySelector('.pxc-pdp-title h1');
    if (!t || !h) return;
    var main = '';
    for (var i = 0; i < h.childNodes.length; i++) {
      if (h.childNodes[i].nodeType === 3) main += h.childNodes[i].textContent;
    }
    main = main.trim();
    if (main) setText(t, main);
  }

  /* ---------- Re-apply after theme re-renders (variant morphs, cart refreshes) ---------- */
  var queued = false;
  function run() {
    queued = false;
    try { applyShipDates(); } catch (e) {}
    try { applyPickers(); } catch (e) {}
    try { applyStickyTitle(); } catch (e) {}
  }
  function schedule() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  function start() {
    run();
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('variant:update', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
